import { StatusCondicaoEspecial } from 'src/tipos/condicao-especial'

/**
 * Por que o consultor não pode editar a condição, dito pelo status — antes era
 * sempre "Só é possível editar antes do aceite do aluno", inclusive numa
 * condição expirada ou cancelada que ninguém aceitou.
 *
 * A expirada sem aluno é editável (reabre ao estender a validade); se chegou
 * aqui, é porque o aluno já tinha começado a preencher.
 */
export const motivoEdicaoBloqueada = (status: string): string => {
  switch (status) {
    case StatusCondicaoEspecial.Cancelada:
      return 'Condição cancelada. Use Duplicar para criar uma nova.'
    case StatusCondicaoEspecial.Expirada:
      return 'Condição expirada depois que o aluno começou a preencher. Use Duplicar para criar uma nova.'
    default:
      return 'Só é possível editar antes do aceite do aluno.'
  }
}
